import { Toast } from 'react-bootstrap';
import ToastContainer from 'react-bootstrap/ToastContainer';
import styled from 'styled-components';
import COLOURS from '../../../variables/colours';
import { slideInAndOut } from '../../../variables/animations';

export const StyledToastsContainer = styled(ToastContainer)`
    position: fixed;
    right: 1%;
    color: black; 
    top: 2%;
    z-index: 9999;
    pointer-events: auto;
`

export const StyledToast = styled(Toast)`
  background-color: ${props => {
        switch (props.status) {
            case 'success':
                return COLOURS.success;
            case 'failure':
                return COLOURS.failure;
            case 'info':
                return COLOURS.info;
            default:
                return COLOURS.info; // Default color for unknown status
        }
    }};
  color: black;
  transform: translateX(100%);
  animation: ${slideInAndOut} 5s ease-in-out forwards;
`;